import { graphql } from 'react-relay';

export default graphql`
  query ViewerQuery {
    viewer {
      ...EventIndexContainer_viewer
      ...EventCreateContainer_viewer
      ...LeadCaptureContainer_viewer
      ...LinkContainer_viewer
      ...KioskContainer_viewer
      ...EmbedContainer_viewer
      ...AvailabilityCalendarContainer_viewer
      ...AvailabilityCheckerContainer_viewer
      ...TemplateListContainer_viewer
    }
  }
`;



// WEBPACK FOOTER //
// ./webpack/routes/ViewerQuery.js